import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../common/Header/Header";
import { parseJwt } from "../../utils/parseJwt";
import { useSelector } from "react-redux";
import FilesPopup from "../chat/FilesPopup/FilesPopup";
import { useSelectedFile } from "../../context/SelectedFileContext";
import { useMenu } from "../../context/MenuContext";
import api from "../../services/BackendServices";

const LayoutNavbar: React.FC = () => {
  const [files, setFiles] = useState<any[]>([]);
  const [showFilesPopup, setShowFilesPopup] = useState<boolean>(false);

  const { setSelectedFile } = useSelectedFile();
  const { toggleMenu } = useMenu();

  const token = useSelector((state: any) => state.userProfile?.token);
  const USER_ID: string | null = token ? parseJwt(token)?.id : null;

  const closeFilesPopup = () => {
    setShowFilesPopup(false);
  };

  const fetchFiles = async () => {
    if (!USER_ID) return;

    try {
      const response = await api.GeneralServices.fetchFiles(USER_ID);
      const result = response.data;

      if (result.message === "success") {
        setFiles(result.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleFilesButtonClick = async () => {
    await fetchFiles();
    setShowFilesPopup(true);
  };

  return (
    <div className="layout">
      <Header
        onFilesButtonClick={handleFilesButtonClick}
        toggleMenu={toggleMenu}
      />
      <main>
        <Outlet />
      </main>
      {showFilesPopup && USER_ID && (
        <FilesPopup
          files={files}
          onClose={closeFilesPopup}
          setSelectedFile={setSelectedFile}
          userId={USER_ID}
        />
      )}
    </div>
  );
};

export default LayoutNavbar;
